import React from 'react';

const Select = ({
  label = '',
  value,
  onChange,
  options = [],
  error = '',
  required = false,
  disabled = false,
  placeholder = 'Select an option',
  name = ''
}) => {
  const containerStyle = {
    marginBottom: '16px',
    width: '100%'
  };

  const labelStyle = {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: 'var(--text-primary)',
    marginBottom: '6px'
  };

  const selectStyle = {
    width: '100%',
    padding: '12px',
    fontSize: '14px',
    border: `1px solid ${error ? '#ef4444' : 'var(--border)'}`,
    borderRadius: '8px',
    background: 'var(--surface)',
    color: 'var(--text-primary)',
    outline: 'none',
    transition: 'all 0.2s ease',
    fontFamily: 'inherit',
    cursor: disabled ? 'not-allowed' : 'pointer'
  };

  const errorStyle = {
    fontSize: '12px',
    color: '#ef4444',
    marginTop: '4px'
  };

  return (
    <div style={containerStyle}>
      {label && (
        <label style={labelStyle}>
          {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
        </label>
      )}
      <select
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        name={name}
        style={selectStyle}
        onFocus={(e) => {
          e.target.style.borderColor = error ? '#ef4444' : 'var(--primary)';
          e.target.style.boxShadow = error 
            ? '0 0 0 3px rgba(239, 68, 68, 0.1)' 
            : '0 0 0 3px var(--primary-light)';
        }}
        onBlur={(e) => {
          e.target.style.borderColor = error ? '#ef4444' : 'var(--border)';
          e.target.style.boxShadow = 'none';
        }}
      >
        <option value="">{placeholder}</option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <div style={errorStyle}>{error}</div>}
    </div>
  );
};

export default Select;